import { ActionColumnFormat } from './ColumnsFormatters/ActionColumnFormat';

export const columnsUpcomingSessions = (onCheckbox, all) => {
	let formatedData = [
		{
			dataField: 'sector',
			text: 'Representación',
			classes: 'text-center',
		},
		{
			dataField: 'name',
			text: 'Miembro',
			classes: 'text-center',
		},
		{
			dataField: 'position',
			text: 'Cargo',
			classes: 'text-center',
		},
		{
			dataField: 'id',
			text: 'Acciones',
			classes: 'text-center',
			headerClasses: 'text-center',
			formatter: ActionColumnFormat,
			formatExtraData: {
				onCheckbox,
				all,
			},
		},
	];

	return formatedData;
};
export const columnsAnnouncement = (onCheckbox, all) => [
	{
		dataField: 'sector',
		text: 'Representación',
		classes: 'text-center',
	},
	{
		dataField: 'name',
		text: 'Miembro',
		classes: 'text-center',
	},
	{
		dataField: 'position',
		text: 'Cargo',
		classes: 'text-center',
	},
	{
		dataField: 'id',
		text: 'Acciones',
		classes: 'text-center',
		headerClasses: 'text-center',
		formatter: ActionColumnFormat,
		formatExtraData: {
			onCheckbox,
			all,
		},
	},
];

export const columnsSelected = () => [
	{
		dataField: 'sector',
		text: 'Representación',
		classes: 'text-center',
	},
	{
		dataField: 'name',
		text: 'Miembro',
		classes: 'text-center',
	},
	{
		dataField: 'position',
		text: 'Cargo',
		classes: 'text-center',
	},
];

export const buttons = (post) => [
	{
		title: 'Publicar y Enviar Sesión',
		color: 'light-primary',
		onClick: post,
		className: 'mt-lg-15 ml-lg-2 ',
	},
];

export const btnsSave = (onSaveData, setSaveConv, flagBtns) => [
	{
		title: 'Guardar convocatoria',
		onClick: onSaveData,
		className: flagBtns ? 'd-none' : 'mt-lg-5 float-right',
	},
	{
		title: 'Mostrar convocatoria',
		onClick: setSaveConv,
		className: flagBtns === false ? 'd-none' : 'mt-lg-5 float-right',
	},
];
